import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mt-10 text-lg font-bold flex flex-col items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title align-center" }, "MoodConnect Pricing ")
], -1)
const _hoisted_2 = { class: "flex content-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubscriptionSelection = _resolveComponent("SubscriptionSelection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SubscriptionSelection)
    ])
  ], 64))
}